import React, { useEffect } from "react";
import { Route, Redirect } from "react-router-dom";
import { AuthContext } from "context/Auth";
import { isTokenValid } from "utils/auth";

export default function PrivateRoute({
  layout: Layout,
  component: Component,
  auth,
  title,
  ...rest
}) {
  const { isAuthenticated, setIsAuthenticated } = React.useContext(AuthContext);
  useEffect(() => {
    if (!localStorage.wrn_admin_de || !isTokenValid()) {
      localStorage.removeItem("wrn_admin_de");
      localStorage.removeItem("wrn_data_entry_token");
      setIsAuthenticated(false);
    }
  }, []);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (isAuthenticated)
          return (
            <Layout>
              <section className="main__parent--container">
                <Component {...props} />
              </section>
            </Layout>
          );
        else return <Redirect to="/" />;
      }}
    />
  );
}
